import { Tooltip, useTheme } from '@material-ui/core';
import { ChatTray } from '@src/types/chats';
import { useIntl } from 'react-intl';
import { PersonOffIcon, SpeakerNotesOffIcon, TimelapseIcon } from './SvgIcons';
import IconWrapper from '../Common/IconWrapper';

export type ChatStatusIndicatorProps = {
  chat: ChatTray;
};

const ChatStatusIndicator: React.FC<ChatStatusIndicatorProps> = ({ chat }) => {
  const intl = useIntl();
  const theme = useTheme();

  const {
    closeToMaxTime = false,
    hasPassedMaxTime = false,
    lastMsgSentAt = 0,
    lastMsgReceivedAt = 0,
  } = chat;

  const lastMsgSentIsNewer = lastMsgSentAt > lastMsgReceivedAt;
  const lastMsgReceivedIsNewer = lastMsgReceivedAt > lastMsgSentAt;

  return (
    <>
      {hasPassedMaxTime && lastMsgSentIsNewer && (
        <Tooltip
          title={intl.formatMessage({
            id: 'Console.ChatListItem.tooltip.ChatBlocked',
          })}
        >
          <IconWrapper fontSize={15} color={theme.b2chatred[500]}>
            {PersonOffIcon}
          </IconWrapper>
        </Tooltip>
      )}

      {hasPassedMaxTime && lastMsgReceivedIsNewer && (
        <Tooltip
          title={intl.formatMessage({
            id: 'Console.ChatListItem.tooltip.ChatBlocked',
          })}
        >
          <IconWrapper fontSize={13} color={theme.b2chatred[500]}>
            {SpeakerNotesOffIcon}
          </IconWrapper>
        </Tooltip>
      )}

      {closeToMaxTime && (
        <Tooltip
          title={intl.formatMessage({
            id: 'Console.ChatListItem.tooltip.Timelimit',
          })}
        >
          <IconWrapper fontSize={14} color={theme.b2chatorange[600]}>
            {TimelapseIcon}
          </IconWrapper>
        </Tooltip>
      )}
    </>
  );
};

export default ChatStatusIndicator;
